export { default as Img200 } from './processed/200/Underworld-Awakening.jpg';
export { default as Img400 } from './processed/400/Underworld-Awakening.jpg';
export { default as Imgthumb } from './processed/thumb/Underworld-Awakening.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Underworld-Awakening.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Underworld-Awakening.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      68,
      148,
      188
    ],
    "_population": 3,
    "_hsl": [
      0.5555555555555555,
      0.4724409448818898,
      0.5019607843137255
    ]
  },
  "LightVibrant": {
    "_rgb": [
      139,
      200,
      220
    ],
    "_population": 10,
    "_hsl": [
      0.5411522633744856,
      0.5364238410596028,
      0.7039215686274509
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      20,
      84,
      148
    ],
    "_population": 1,
    "_hsl": [
      0.5833333333333334,
      0.7619047619047618,
      0.3294117647058824
    ]
  },
  "Muted": {
    "_rgb": [
      164,
      119,
      95
    ],
    "_population": 70,
    "_hsl": [
      0.05797101449275361,
      0.27490039840637454,
      0.5078431372549019
    ]
  },
  "LightMuted": {
    "_rgb": [
      213,
      197,
      180
    ],
    "_population": 380,
    "_hsl": [
      0.08585858585858586,
      0.28205128205128216,
      0.7705882352941177
    ]
  },
  "DarkMuted": {
    "_rgb": [
      66,
      69,
      62
    ],
    "_population": 2400,
    "_hsl": [
      0.2380952380952379,
      0.05343511450381677,
      0.2568627450980392
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Underworld-Awakening.js